/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    createFeatureSelector,
    createSelector,
} from '@ngrx/store';

import { IControllerSiteState } from './controller-site.state';

export const controllerSiteStateFeatureKey = 'controllerSiteState';

const selectControllerSiteState =
    createFeatureSelector<IControllerSiteState>(controllerSiteStateFeatureKey);

const selectName = createSelector(
    selectControllerSiteState,
    (controllerSiteState: IControllerSiteState) => controllerSiteState.name,
);

const selectTenantRef = createSelector(
    selectControllerSiteState,
    (controllerSiteState: IControllerSiteState) => controllerSiteState.tenant_ref,
);
const selectUrl = createSelector(
    selectControllerSiteState,
    (controllerSiteState: IControllerSiteState) => controllerSiteState.url,
);
const selectUuid = createSelector(
    selectControllerSiteState,
    (controllerSiteState: IControllerSiteState) => controllerSiteState.uuid,
);

export const ControllerSiteSelectors = {
    selectName,
    selectTenantRef,
    selectUrl,
    selectUuid,
};
